(function () {
    'use strict';

    var module = angular.module('uwAgenda.email', [
        'uwAgenda.help',
        'uwAgenda.global'
    ]);

    module.config(['$stateProvider', 'HelpCategoryEnum', EmailConfigFn]);
    
    function EmailConfigFn($stateProvider, HelpCategoryEnum) {
        $stateProvider
            .state('Home.Email', {
                url: 'Email',
                templateUrl: '/app/email/templates/email.template.html',
                controller: 'EmailController',
                controllerAs: 'vm',
                resolve: {
                    deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'uwAgenda Email',
                            insertBefore: '#ng_load_plugins_before',
                            files: [
                                '/assets/lib/lazy-loaded/profile.css',
                                '/assets/lib/lazy-loaded/profile.min.js'
                            ]
                        });
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'email' | translate}}"
                }
            })
            .state('Home.Email.Overview', {
                url: '/Overview',
                templateUrl: '/app/email/overview/templates/email-overview.template.html',
                controller: 'EmailOverviewController',
                controllerAs: 'vm',
                params: {
                    all: false,
                    helpCategory: HelpCategoryEnum.Email
                },
                resolve: {
                    emails: ['SharedAgendaService', 'MessagePaginationService', '$stateParams', function (SharedAgendaService, MessagePaginationService, $stateParams) {
                        MessagePaginationService.init(SharedAgendaService.currentUser().id, 10, $stateParams.all);
                        
                        return MessagePaginationService.search();
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'overview' | translate}}"
                }
            });
    }
})();